class SectionAsync extends window.PURELEI.CustomElement() {
  async connectedCallback () {
    super.connectedCallback()

    this.isBusy = true

    const html = this.processData(
      await window.PURELEI.sectionRenderer.fetchSingle(
        this.sectionId,
        this.sectionsUrl,
      ),
    )

    // Added due to products not sold in markets will error
    if (this.isNosto) {
      if (html.includes('Liquid error')) {
        this.removeParentElement()
        return
      }
    }

    this.sectionHTML = window.PURELEI.sectionRenderer.getOuterHtml(html, {
      id: this.shopifySectionId,
    })

    // window.iWish.checkIwishColl()

    this.isBusy = false
  }

  /**
   * Replaces variables in the section HTML
   *
   * @param {string} html Section HTML containing variables that need to be replaced
   * @returns {string} HTML with variables replaced
   */
  processData (html) {
    Object.keys(this.data).forEach((key) => {
      const replacers = [new RegExp(`{{ ${key} }}`, 'g')]
      replacers.forEach((replacer) => {
        html = html.replace(replacer, this.data[key])
      })
    })
    return html
  }

  /**
   * Removes the parent element
   */
  removeParentElement () {
    const elementToRemove = this.parentIdentifier
      ? this.closest(this.parentIdentifier)
      : this
    elementToRemove.remove()
  }

  /**
   * @returns {string} The ID of the section to be rendered
   */
  get sectionId () {
    return this.dataset?.sectionId
  }

  /**
   * @returns {string} The ID of the section to be rendered
   */
  get shopifySectionId () {
    return `shopify-section-${this.dataset?.sectionId}`
  }

  /**
   * @returns {html} The HTML of the section
   */
  get sectionHTML () {
    return this.innerHTML
  }

  /**
   * @param {html} The HTML to be rendered
   */
  set sectionHTML (html) {
    if (!html) {
      /*
       * When there isn't any HTML we want to remove the parent element
       * to ensure we're not showing other elements of the section
       * such as kicker and title
       */
      this.removeParentElement()
      return
    }
    this.innerHTML = html

    if (this.isNosto) {
      this.querySelectorAll('a').forEach((link) => {
        const url = link.href

        link.href = `${url}${url.includes('?') ? '&' : '?'}${this.nostoParams}`
      })
    }
  }

  /**
   * @param {boolean} Whether or not the element is currently busy
   */
  set isBusy (boolean) {
    this.setAttribute('aria-busy', boolean)
  }

  /**
   * @returns {boolean} Whether or not the element is currently busy
   */
  get isBusy () {
    return this.getAttribute('aria-busy') === 'true'
  }

  /**
   * @returns {HTMLelement} The HTML element containing data to be replaced in the rendered HTML
   */
  get dataEl () {
    return this.els?.data?.element
  }

  /**
   * @returns {Object} An object containing data to be replaced in the rendered HTML
   */
  get data () {
    return this.dataEl ? JSON.parse(this.dataEl.textContent) : {}
  }

  /**
   * @returns {string} The URL from which to request the section
   */
  get url () {
    return this.dataset?.url
  }

  /**
   * @returns {string} Defines the identifier of a parent element
   */
  get parentIdentifier () {
    return this?.dataset?.parentIdentifier
  }

  /**
   * @returns {string} Defines if the element is from Nosto
   */
  get isNosto () {
    return this.dataset.nosto
  }

  /**
   * @returns {string} String of Nosto querystring parameters from the async card
   */
  get nostoParams () {
    if (!this.dataset.url.includes('?')) return

    const urlParams = new URLSearchParams(this.dataset.url.split('?')[1])
    const nostoParams = []

    urlParams.forEach((value, key) => {
      if (key.includes('nosto')) {
        nostoParams.push(`${key}=${value}`)
      }
    })

    return nostoParams.join('&')
  }

  /**
   * @returns {string} The url, pathname and query parameters
   */
  get sectionsUrl () {
    // Check if coming from Nosto
    if (this.isNosto) {
      // Check if a route exists, i.e /fr-fr/
      if (window.Shopify.routes.root) {
        // Make sure the URL maintains the correct route.
        const nostoProductUrl = this.dataset.url
        const fixedUrl = nostoProductUrl.replace(
          '/products/',
          `${window.Shopify.routes.root}products/`,
        )

        return fixedUrl
      } else {
        return (
          this.dataset.url ||
          `${window.location.pathname}${window.location.search}`
        )
      }
    } else {
      return (
        this.dataset.url ||
        `${window.location.pathname}${window.location.search}`
      )
    }
  }
}

if (!customElements.get('section-async')) {
  customElements.define('section-async', SectionAsync)
}
